import { render, staticRenderFns } from "./VesselGroupsWrapper.vue?vue&type=template&id=19e0e91e&scoped=true&"
import script from "./VesselGroupsWrapper.vue?vue&type=script&lang=ts&"
export * from "./VesselGroupsWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e0e91e",
  null
  
)

export default component.exports